export const HIDE_FOOTER_PATHS = [
  "/product-tour/",
]

export const USE_SMALL_FOOTER_PATHS = [
  "/fundraising-with-purpose/",
  "/interview-builder/",
  "/lp/personalized-customer-experience",
  "/webinars/foundations-of-great-service/",
]

export const USE_STATIC_HEADER_PATHS = [
  "/interview-builder/",
  "/pricing/",
  "/pricing/contact-based/",
]

export const USE_STATIC_HEADER_PATHS_REGEX = new RegExp(USE_STATIC_HEADER_PATHS.join("|"))

export const INCLUDE_FIXED_CTA_BAR_PATHS = [
  "^/$",
  "/ai-features/",
  "/analytics/",
  "/beacon-messaging/",
  "/collaboration/",
  "/compare/.+",
  "/customer-champions/",
  "/customer-management/",
  "/customer-referral/.+",
  "/customer-support-channels/",
  "/customer-support/",
  "/for-good/",
  "/help-desk-workflows/",
  "/inbox/",
  "/industry/.+",
  "/integrations/",
  "/knowledge-base/",
  "/platform/",
  "/pricing/",
  "/proactive-messages/",
  "/self-service/",
  "/shared-inbox/",
  "/startups/",
]

export const INCLUDE_FIXED_CTA_BAR_PATHS_REGEX = new RegExp(INCLUDE_FIXED_CTA_BAR_PATHS.join("|"))
